import React from "react"
import useGoogleSheets from "use-google-sheets"
import DiscussTogether from "../../static/images/SVB-Discuss-together.png"
import { getTranslation } from "../scripts/getTranslation"

const SphereViewQuestions = ({ language, id, translations }) => {
  const { data, loading, error } = useGoogleSheets({
    apiKey: "AIzaSyAb_P06-faYkzrsHqYvF7us6kBdfyIpY6M",
    sheetId: "1dHiHr64uZ8pFUjY_mDqOD8SAQtdTxNtKSDjN4AFcy4U",
    sheetsNames: [language],
  })

  if (loading) {
    return null
  }

  if (error) {
    console.log(error)
    return null
  }
  const sheetData = data[0].data
  const rowData = sheetData.find(b => b["ID"] === id)
  const { Q1, Q2, Q3, Q4, CallToAction } = rowData

  if (!Q1 || !Q2) return null

  return (
    <div
      style={{
        display: "block",
        textAlign: "center",
        margin: "10px 0",
        padding: "10px 0",
        borderTop: "0.25px lightgrey solid",
      }}
    >
      <div
        style={{
          width: "100%",
          // maxWidth: '30vw',
          margin: "10px auto 0 auto",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={DiscussTogether}
          alt="Discuss Together"
          style={{
            width: "200px",
            opacity: 1,
          }}
        />
        <p
          style={{
            width: "100%",
            color: "grey",
            fontSize: "70%",
            margin: "-20px 0 0 0",
            textAlign: "center",
            direction: language === "ARB" ? "rtl" : "ltr",
          }}
        >
          {getTranslation(translations, language, "UI", "discuss_icon_caption")}
        </p>
      </div>
      <div
        style={{
          textAlign: "left",
          margin: "30px 0",
          padding: "0 30px",
          direction: language === "ARB" ? "rtl" : "ltr",
        }}
      >
        <ul style={language === "ARB" ? { direction: "rtl" } : {}}>
          <li>{Q1}</li>
          <li>{Q2}</li>
          {Q3 ? <li>{Q3}</li> : null}
          {Q4 ? <li>{Q4}</li> : null}
        </ul>
        {CallToAction ? <p style={{
          textAlign: 'center',
          fontWeight: "bold"
          }}>{CallToAction}</p> : null}
      </div>
    </div>
  )
}

export default SphereViewQuestions